/**
 * Scales the dimensions of images larger than 1MB down to approximately 1MB.
 * All strings here are data URLs.
 */
export function capImageAt1MB(file: Blob, dataURL: string): Promise<string> {
  const canvas = document.createElement("canvas");
  const _1MB = 1000000;
  return new Promise((resolve, reject) => {
    const areaScaleFactor = Math.min(1, _1MB / file.size);
    const lengthScaleFactor = Math.sqrt(areaScaleFactor);
    const image = new Image();
    image.onload = () => {
      const ctx = canvas.getContext("2d");
      if (ctx === null) return reject(new Error("Could not get canvas context"));
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      image.width *= lengthScaleFactor;
      image.height *= lengthScaleFactor;
      canvas.width = image.width;
      canvas.height = image.height;
      ctx.drawImage(image, 0, 0, image.width, image.height);
      resolve(canvas.toDataURL(file.type));
    };
    image.onerror = () => reject(new Error("Could not decode image"));
    image.src = dataURL;
  });
}
